interface InoveiTechBannerProps {
  firstName: string;
  today: string;
}

export function InoveiTechBanner({ firstName, today }: InoveiTechBannerProps) {
  return (
    <div style={{
      position: 'relative',
      width: '100%',
      height: 200,
      borderRadius: 14,
      overflow: 'hidden',
      border: '1px solid #0e2035',
    }}>
      <img
        src="/img/incluirtech_banner.svg"
        alt="IncluirTech"
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      />

      <div style={{ position: 'absolute', bottom: 16, right: 44, textAlign: 'right' }}>
        <p style={{ color: '#fff', fontWeight: 600, fontSize: 13, lineHeight: 1.3, textShadow: '0 1px 4px rgba(0,0,0,0.8)' }}>
          Bem-vindo, <span style={{ color: '#00d4ff' }}>{firstName}</span>
        </p>
        <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11, marginTop: 3, textTransform: 'capitalize', textShadow: '0 1px 4px rgba(0,0,0,0.8)' }}>
          {today}
        </p>
      </div>
    </div>
  );
}
